import { useFieldBase } from './useField';
/**
 * Use a TriStateType atom which internaly gets converted to boolean for checkbox.
 * Make sure the selector returns TriStateType.UNSET as default and that backend set's UNSET
 * as well if the values should be defaulted by the frontend
 */
export function useTriStateCheckbox({ atom, validationSelector, fieldName, disabled = false, disabledSelector, validationEffects = [], i18nVariables, required, defaultValue, }) {
    // get base props of validation fields
    const [{ value, ...baseProps }, saveValue] = useFieldBase({
        atom,
        fieldName,
        disabled,
        disabledSelector,
        validationSelector,
        validationEffects,
        i18nVariables,
        required,
        defaultValue: defaultValue
            ? (value) => {
                // We define a default handler that only set's the value if UNSET is the current value
                // and the developer did not provide a function for special handling
                if (typeof defaultValue !== 'function') {
                    return value === 'unset' ? defaultValue : value;
                }
                return defaultValue(value);
            }
            : undefined,
    });
    return {
        onChange: (event) => saveValue(event.target.checked ? 'true' : 'false'),
        checked: value === 'true',
        ...baseProps,
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationTriStateCheckbox = useTriStateCheckbox;
